import React, { useEffect, useState } from "react";
import classNames from "nq-component/dist/classNames";
import Head from "./Head";
import Body from "./Body";
import CardView from "../common/CardView";
import { Spin } from "antd";
import Pagination from "../Pagination";

const noop = () => {};
const defaultProps = {
  fields: {},
  objects: [],
  dynamicObject: {},
  excludeFields: [],
  excludeOrderFields: [],
  selected: [],
  isExcludeFieldOrder: false,
  progress: false,
  onClick: noop,
  onClickItem: noop,
  onSelect: noop,
  onSelectAll: noop,
  readOnly: false,
  actions: [],
  actionsList: [],
  selectable: false,
  collapsable: false,
  toggleable: false,
  onCollapse: noop,
  onLongPress: noop,
  selectedItem: "",
};

function Table({
  currectRoles,
  empPointer,
  objectId,
  editId,
  print,
  objectData,
  objectDataDis,
  viewObject,
  hrAction,
  assign,
  ofAppearance,
  ofTraining,
  viewService,
  viewLeaves,
  viewSalary,
  viewDisciplinary,
  viewStepIncrement,
  addTraining,
  printTraining,
  viewPayroll,
  payslip,
  payroll,
  voucher,
  remove,
  printPayslip,
  printDisbursement,
  removeDisbursement,
  editPayrollType,
  stepIncrement,
  viewAP,
  viewBasic,
  separateEmployee,
  generateLeaveCard,
  refetch,
  collection,
  className,
  fields,
  objects,
  limit,
  count,
  current,
  loadPagination,
  progress,
  onClick,
  onClickItem,
  selectedItem,
  selected,
  onSelect,
  onSelectAll,
  excludeFields,
  isExcludeFieldOrder,
  excludeOrderFields,
  dynamicObject,
  actions,
  specialColumn,
  actionsList,
  setRef,
  selectable,
  indexCount,
  onCollapse,
  collapsable,
  toggleable,
  onLongPress,
  fieldPointer = [],
  ...props
}) {
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    // console.log("TEST: ", current);
    localStorage.setItem("currentPage", current);
  }, [current]);

  const handleAction = (action, data) => action(data);

  const fieldImage = Object.keys(fields).find(
    (field) =>
      (fields[field]._type === "Image" && fields[field].read !== false) ||
      fields[field].detail,
  );

  const newCurrentValue = (value) => {
    loadPagination(value);
  };

  const hasItems = (arr) => Array.isArray(arr) && arr.length > 0;

  const startIndex = (currentPage - 1) * limit;
  const endIndex = startIndex + limit;

  const paginatedObjects = objects.slice(startIndex, endIndex);
  // const objects.filter(item => typeof item.timeRecStats === "")
  return (
    <div className="position-relative" style={{ marginTop: "1px" }}>
      <div
        className={classNames("table-responsive shadow-lg", className)}
        ref={setRef}
        {...props}
      >
        <CardView
          style={{
            borderRadius: 0,
            minHeight: "10rem",
          }}
        >
          <div
            style={{
              overflowX: "scroll",
              overflowY: "scroll",
              maxHeight: "30rem",
              scrollbarWidth: "thin",
              scrollbarColor: "rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.1)",
            }}
          >
            <style>
              {`
                .scrollable-container::-webkit-scrollbar {
                  width: 8px;
                  height: 8px;
                }
                .scrollable-container::-webkit-scrollbar-track {
                  background: rgba(0, 0, 0, 0.1);
                }
                .scrollable-container::-webkit-scrollbar-thumb {
                  background-color: rgba(0, 0, 0, 0.2);
                  border-radius: 10px;
                }
              `}
            </style>
            <table className="mb-0 w-100">
              <thead
                className="bg-light-subtle position-sticky top-0"
                style={{ zIndex: 100 }}
              >
                <Head
                  empPointer={empPointer}
                  indexCount={indexCount}
                  selectable={selectable}
                  fields={fields}
                  excludeFields={excludeFields}
                  isExcludeFieldOrder={isExcludeFieldOrder}
                  excludeOrderFields={excludeOrderFields}
                  dynamicObject={dynamicObject}
                  specialColumn={specialColumn}
                  actionsList={actionsList}
                  selected={selected}
                  onSelectAll={onSelectAll}
                  objects={objects}
                  {...(hasItems(fieldPointer) ? { fieldPointer } : {})}
                />
              </thead>
              <tbody className="bg-white">
                {paginatedObjects.length === 0 && !progress && (
                  <tr>
                    <td
                      className="text-center fs-lg overflow-hidden"
                      colSpan={Object.keys(fields).length + 1}
                    >
                      <div className="row">
                        <div className="d-flex align-items-center justify-content-center pt-2">
                          <img width="120" src={"/noData.svg"} alt="No Data" />
                        </div>
                        <p className="text-center">No Data</p>
                      </div>
                    </td>
                  </tr>
                )}
                <Body
                  currectRoles={currectRoles}
                  empPointer={empPointer}
                  indexCount={indexCount}
                  handleDelete={(id) => handleAction(objectId, id)}
                  handleEdit={(id) => handleAction(editId, id)}
                  handlePrint={(data) => handleAction(print, data)}
                  singleObjet={(data) => handleAction(objectData, data)}
                  singleObjetDis={(data) => handleAction(objectDataDis, data)}
                  viewObject={(data) => handleAction(viewObject, data)}
                  HRAction={(data) => handleAction(hrAction, data)}
                  increment={(data) => handleAction(stepIncrement, data)}
                  separate={(data) => handleAction(separateEmployee, data)}
                  generate={(data) => handleAction(generateLeaveCard, data)}
                  assignBank={(data) => handleAction(assign, data)}
                  appearance={(data) => handleAction(ofAppearance, data)}
                  addTrain={(data) => handleAction(addTraining, data)}
                  printTrain={(data) => handleAction(printTraining, data)}
                  removePayroll={(data) => handleAction(remove, data)}
                  training={(data) => handleAction(ofTraining, data)}
                  payrollViewing={(data) => handleAction(viewPayroll, data)}
                  payslipViewing={(data) => handleAction(payslip, data)}
                  payrollListing={(data) => handleAction(payroll, data)}
                  payrollVoucher={(data) => handleAction(voucher, data)}
                  payslipPrinting={(data) => handleAction(printPayslip, data)}
                  serviceRecord={(data) => handleAction(viewService, data)}
                  leavesRecord={(data) => handleAction(viewLeaves, data)}
                  salaryAdjustment={(data) => handleAction(viewSalary, data)}
                  onEditPayrollType={(data) =>
                    handleAction(editPayrollType, data)
                  }
                  disciplinaryRecord={(data) =>
                    handleAction(viewDisciplinary, data)
                  }
                  stepIncrement={(data) =>
                    handleAction(viewStepIncrement, data)
                  }
                  disbursementPrinting={(data) =>
                    handleAction(printDisbursement, data)
                  }
                  deleteDisbursement={(data) =>
                    handleAction(removeDisbursement, data)
                  }
                  handleViewAP={(data) => handleAction(viewAP, data)}
                  handleViewBasic={(data) => handleAction(viewBasic, data)}
                  // onEditPayrollType={(data) =>
                  //   handleAction(editPayrollType, data)
                  // }
                  refetch={refetch}
                  objects={paginatedObjects}
                  collection={collection}
                  fields={fields}
                  excludeFields={excludeFields}
                  selected={selected}
                  selectable={selectable}
                  onSelect={onSelect}
                  onClick={onClick}
                  onLongPress={onLongPress}
                  specialColumn={specialColumn}
                  actionsList={actionsList}
                  collapsable={collapsable}
                  toggleable={toggleable}
                  onCollapse={onCollapse}
                  actions={actions}
                  onClickItem={onClickItem}
                  selectedItem={selectedItem}
                  fieldImage={fieldImage}
                  {...(hasItems(fieldPointer) ? { fieldPointer } : {})}
                />
                {progress && (
                  <tr>
                    <td colSpan={Object.keys(fields).length + 1}>
                      {/* <Progress className="fs-sm" /> */}
                      <div className="d-flex align-items-center justify-content-center p-5">
                        <Spin size="large" />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </CardView>
      </div>
      <div style={{ marginTop: "1px" }}>
        <CardView style={{ borderRadius: 0 }}>
          {collection.collection !== "schedule" && (
            <div className="d-flex justify-content-between align-items-center">
              <small className="font-size-xs text-muted">
                {"page"} {current} {"of"} {Math.ceil(count / limit)}
              </small>
              <Pagination
                count={Math.ceil(count / limit)}
                current={current}
                delta={current}
                onClick={(value) => newCurrentValue(value)}
              />
              <small className="font-size-xs text-muted">
                {"pageSize"} {limit}
              </small>
            </div>
          )}
        </CardView>
      </div>
    </div>
  );
}

Table.defaultProps = defaultProps;
export default Table;
